import { Button, ChevronDownIcon } from '@mr-yum/frontend-ui'
import React, { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { OrderingWindow } from '@/components/Ordering/OrderingWindow'
import { OrderingType } from '@/gql/graphql'
import { useLoggerLegacy } from '@/hooks/useLogger'

import { useSheetToggle } from './utils/sheetUtils'

interface Props {
  orderingType: OrderingType
  hasNoPaths?: boolean
  isAsap?: boolean
  startDate: string | null | undefined
  orderingWindowEndDate: string | null | undefined
}

export const OrderingWindowButton = ({
  orderingType,
  hasNoPaths,
  isAsap,
  startDate,
  orderingWindowEndDate,
}: Props) => {
  const { logEventLegacy } = useLoggerLegacy()
  const sheetToggle = useSheetToggle()
  const intl = useIntl()

  const handleOnClick = useCallback(() => {
    logEventLegacy('Clicked on ordering window selector')
    void sheetToggle({
      sheet: 'order-window',
    })
  }, [logEventLegacy, sheetToggle])

  if (hasNoPaths) {
    return null
  }

  return (
    <Button
      type="button"
      variant="link-primary"
      size="sm"
      onClick={handleOnClick}
      className="min-h-5 items-center gap-0"
      aria-label={intl.formatMessage({
        defaultMessage: 'Change ordering window',
        id: 'yJPkAI',
      })}
      data-testid="change-ordering-window"
      rightIcon={
        <ChevronDownIcon width={20} height={20} className="flex-shrink-0" />
      }
    >
      {startDate && (
        <OrderingWindow
          orderingType={orderingType}
          startDate={startDate}
          endDate={orderingWindowEndDate}
          className="line-clamp-6 text-left"
        />
      )}

      {!startDate &&
        !isAsap &&
        intl.formatMessage({
          defaultMessage: 'Select ordering window',
          id: 'namfZU',
        })}

      {isAsap && (
        <div data-testid="asap-text">
          <FormattedMessage defaultMessage="ASAP" id="K5T4eC" />
        </div>
      )}
    </Button>
  )
}
